<template>
  <div class="inputs-dialog"
       :class="{ 'inputs-dialog--fixed': fixed }">
    <div class="inputs-dialog__parent"
         :style="{ width, height, maxHeight: maxHeight + 'px' }">
      <div class="inputs-dialog__parent__header">
        <h2 class="inputs-dialog__parent__header__title">
          {{ title }}
        </h2>

        <button class="inputs-dialog__parent__header__button"
                @click="closeDialog">
          <font-awesome-icon
            class="inputs-dialog__parent__header__button__icon"
            :icon="['far', 'circle-xmark']"
          />
        </button>
      </div>

      <div class="inputs-dialog__parent__content-parent">
        <div class="py-2 px-2">
          <div class="inputs-dialog__parent__content-parent__content">
            <slot name="content" />
          </div>
        </div>
      </div>

      <div class="inputs-dialog__parent__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VoipModal',
    props: {
      title: {
        type: String,
        required: true,
        default: 'Modal Title',
      },
      height: {
        type: [String, Number],
        required: false,
      },
      width: {
        type: [String, Number],
        required: false,
      },
      maxHeight: {
        type: [String, Number],
        required: false,
      },
      fixed: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['closeDialog'],
    methods: {
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
  };
</script>

<style lang="scss" scoped>
.inputs-dialog {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1a1a1a65;
  z-index: 20;
  &--fixed {
    position: fixed;
  }

  &__parent {
    border-radius: 24px;
    background: var(--shadesWhite);
    box-shadow: var(--shadowFour);
    width: 545px;
    z-index: 12;

    @include responsive(max, 991px) {
      width: 350px;
    }

    &__header {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid var(--gray500);

      &__button {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: var(--gray50);
        display: flex;
        align-items: center;
        justify-content: center;

        &__icon {
          color: var(--gray600);
          font-size: 20px;
        }
      }

      &__title {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
        color: var(--color-base-500, #095ea6);
      }
    }

    &__content-parent {
      height: calc(100% - 80.8px - 71.8px);
      padding: 16px 8px;
    }

    &__footer {
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: end;
      border-top: 1px solid var(--gray500);
      gap: 8px;
    }
  }
}
</style>
